import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/share_stroke"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2C10.6716 2 10 2.67157 10 3.5C10 3.54353 10.0019 3.58663 10.0055 3.62922L10.0528 3.60557L10.6001 4.70018C10.8508 4.88844 11.1624 5 11.5 5C12.3284 5 13 4.32843 13 3.5C13 2.67157 12.3284 2 11.5 2ZM8 3.5C8 3.86641 8.0563 4.21967 8.16073 4.5516L6.70324 5.28034C6.10165 4.79238 5.33497 4.5 4.5 4.5C2.567 4.5 1 6.067 1 8C1 9.933 2.567 11.5 4.5 11.5C5.42194 11.5 6.26063 11.1435 6.88576 10.5609L8.23532 11.2357C8.08335 11.6278 8 12.0542 8 12.5C8 14.433 9.567 16 11.5 16C13.433 16 15 14.433 15 12.5C15 10.567 13.433 9 11.5 9C10.7547 9 10.0638 9.23296 9.49614 9.63004L7.90046 8.8322C7.96551 8.56547 8 8.28676 8 8C8 7.63359 7.9437 7.28033 7.83927 6.9484L9.29676 6.21966C9.89835 6.70762 10.665 7 11.5 7C13.433 7 15 5.433 15 3.5C15 1.567 13.433 0 11.5 0C9.567 0 8 1.567 8 3.5ZM4.5 6.5C3.67157 6.5 3 7.17157 3 8C3 8.82843 3.67157 9.5 4.5 9.5C5.32843 9.5 6 8.82843 6 8C6 7.17157 5.32843 6.5 4.5 6.5ZM10 12.5C10 11.6716 10.6716 11 11.5 11C12.3284 11 13 11.6716 13 12.5C13 13.3284 12.3284 14 11.5 14C10.6716 14 10 13.3284 10 12.5Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { ShareStroke16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var ShareStroke16 = createIcon(IconComponent);